import { CLOUD_API_NAME_IDENTITY } from '@/client_config';

/** Edge (per-site) API ids — URL roots in `API_ENDPOINT_ROOTS`. Cloud SaaS ids come from `client_config` via `CLOUD_API_NAME_IDENTITY`. */
const EDGE_API_NAMES = {
  automationApi: 'automationApi',
  bargecontrolApi: 'bargecontrolApi',
  bridgeApi: 'bridgeApi',
  cameracontrolApi: 'cameracontrolApi',
  deviceDiscoveryApi: 'deviceDiscoveryApi',
  eventApi: 'eventApi',
  feedingApi: 'feedingApi',
  generatorApi: 'generatorApi',
  gioApi: 'gioApi',
  hybridPowerApi: 'hybridPowerApi',
  inventoryApi: 'inventoryApi',
  measurementApi: 'measurementApi',
  mediaserverApi: 'mediaserverApi',
  morthandlingApi: 'morthandlingApi',
  notificationApi: 'notificationApi',
  opcUaServerApi: 'opcUaServerApi',
  orbitApi: 'orbitApi',
  orbitLedApi: 'orbitLedApi',
  orbitoneApi: 'orbitoneApi',
  servicesApi: 'servicesApi',
  userconfigApi: 'userconfigApi',
  waterlinkedApi: 'waterlinkedApi',
} as const;

export const API_NAMES = {
  ...CLOUD_API_NAME_IDENTITY,
  ...EDGE_API_NAMES,
} as const;

export type ApiNameType = keyof typeof API_NAMES;
export type EdgeApiNameType = keyof typeof EDGE_API_NAMES;

export type ApiMap = Record<ApiNameType, string>;

export const API_ENDPOINT_ROOTS: Record<EdgeApiNameType, string> = {
  automationApi: 'automation-api',
  bargecontrolApi: 'bargecontrol-api',
  bridgeApi: 'sitecontrol-bridge',
  cameracontrolApi: 'cameracontrol-api',
  deviceDiscoveryApi: 'devicediscovery-api',
  eventApi: 'event-api',
  feedingApi: 'feeding-api',
  generatorApi: 'generator-api',
  gioApi: 'gio-api',
  hybridPowerApi: 'hybrid-power-api',
  inventoryApi: 'inventory-api',
  measurementApi: 'measurement-api',
  mediaserverApi: 'mediaserver-api',
  morthandlingApi: 'morthandling-api',
  notificationApi: 'notification-api',
  opcUaServerApi: 'opcuaserver-api',
  orbitApi: 'orbit-api',
  orbitLedApi: 'orbitled-api',
  orbitoneApi: 'orbitone-api',
  servicesApi: 'services-api',
  userconfigApi: 'userconfig-api',
  waterlinkedApi: 'waterlinked-api',
};

/** Edge DNS zone used when the deployment does not supply one (`edgeDnsZone` cluster-var). */
export const DEFAULT_EDGE_DNS_ZONE = 'edge.scaleaq.net';

/** Host label of the Feedstation web app, served on the same edge zone as the site's APIs. */
export const FEEDSTATION_APP_ROOT = 'feedstation';
